const Style = () => ({
  flex__bw: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    // padding: '2rem 1.2rem',
  },

  heading: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#263238',
    lineHeight: '19px',
    paddingBottom: '1rem',
  },
  para: {
    fontSize: '13px',
    fontWeight: '500',
    color: '#6D7D8B',
    lineHeight: '20.7px',
  },
  texts__side: {
    display: 'flex',
    flexDirection: 'column',
    width: '175px',
    // paddingRight: '12px',
    paddingTop: '2rem',
  },
  search__round__btn: {
    padding: '0',
  },
  disbale__icon__search: {
    '& svg': {
      '& circle': {
        fill: 'rgba(109, 125, 139, 0.5)',
      },
      '& path': {
        stroke: 'rgb(45, 68, 87)',
      },
    },
  },
  width__fields: {
    width: 'calc(100% - 175px)',
  },
  data__field: {
    background: '#fff',
    border: '1px solid #AEB6B7',
    borderRadius: '100px',
    height: '42px',
    marginRight: '.7rem',
    width: 'calc(100% - 36px)',
    '& .MuiInputBase-root': {
      height: '100%',
      padding: '0 1rem',
      '& input': {
        height: '100%',
        fontSize: '13px',
        fontWeight: '500',
        color: '#000',
        padding: '0',
      },
    },
  },
  width__w__state: {
    width: 'calc(100% - 126px)',
  },

  w__state: {
    width: '90px',
    marginRight: '.7rem',
  },
  root__dropdown__main: {
    width: 'calc(100% - 90px)',
    position: 'absolute',
    zIndex: '999',
    top: '3rem',
    left: '0%',
    boxShadow: '0 8px 30px rgba(161, 191, 218, 0.16)',
    padding: '0 1rem',
    borderRadius: '15px',
    background: '#fff',
  },
  dropdown__menu__text: {
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#6D7D8B',
    padding: '1rem 0',
    cursor: 'pointer',
    borderBottom: '0.25px solid #D4DCE8',
    '&:last-child': {
      borderBottom: '0',
    },
  },
});

const customSelectStyle = {
  background: '#fff',
  borderColor: '#AEB6B7',
  padding: '7px 12px',
  borderRadius: '50vw',
  color: '#000',
  fontSize: '13px',
  fontWeight: '600',
  lineHeight: '14px',
  width: 'auto',
};

export { Style, customSelectStyle };
